import { render, staticRenderFns } from "./DepartmentTagInPositionForm.vue?vue&type=template&id=2e936d79&scoped=true"
import script from "./DepartmentTagInPositionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentTagInPositionForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentTagInPositionForm.vue?vue&type=style&index=0&id=2e936d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e936d79",
  null
  
)

export default component.exports